import { connect } from 'react-redux'

import CustomerSummary from '../components/customer-summary'

const mapStateToProps = ({ initial: { endpoints, user } }) => ({
    customerAPIURL: endpoints.customerAPIURL,
})

export default connect(mapStateToProps)(CustomerSummary)
